import { Injectable } from '@angular/core';

@Injectable()
export class UtilsService {
    isValidNPN(text: string): boolean {
        return /^(?!0)[0-9]*$/.test(text)
    }
}